import { ENV_CONFIG } from '../config/environment';

function getAuthToken() {
  return (
    localStorage.getItem('token') ||
    localStorage.getItem('planillas_sanctum_token') ||
    localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY)
  );
}

function resolverUrlArchivoPublico(url) {
  if (!url) return null;
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  const base = ENV_CONFIG.API_BASE_URL.replace(/\/api\/?$/, '');
  return `${base}${url.startsWith('/') ? url : `/${url}`}`;
}

export async function obtenerLogoEmpresaUrl(empresaId) {
  if (!empresaId) return null;
  try {
    const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/get-logo/${empresaId}`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        Accept: 'application/json',
      },
    });
    if (!response.ok) return null;
    const result = await response.json();
    return result.success && result.logo_url ? resolverUrlArchivoPublico(result.logo_url) : null;
  } catch {
    return null;
  }
}

export async function obtenerLogoEmpresaBase64(empresaId) {
  if (!empresaId) return null;
  try {
    const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/get-logo-base64/${empresaId}`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        Accept: 'application/json',
      },
    });
    if (!response.ok) return null;
    const result = await response.json();
    return result.success && result.logo_base64 ? result.logo_base64 : null;
  } catch {
    return null;
  }
}

export async function obtenerLogoEmpresaParaVista(empresaId) {
  if (!empresaId) return null;

  const base64 = await obtenerLogoEmpresaBase64(empresaId);
  if (base64) return base64;

  return obtenerLogoEmpresaUrl(empresaId);
}
